import { CASES } from "./constants";

/**
 * Updates offer history state in the Redux store.
 * @param {Object} payload - State properties to merge into the offerHistory slice
 */
export const updateOfferHistory = (payload) => {
  return { type: CASES.UPDATE_OFFER_HISTORY, payload };
};

/**
 * Updates the internal filters used for offer history filtering.
 * Merges new filter values into existing filters and persists to localStorage.
 * @param {Object} payload - Filter values to merge into internalFilters, plus offerId for persistence
 */
export const updateOfferHistoryFilters = (payload) => {
  return { type: CASES.UPDATE_OFFER_HISTORY_FILTERS, payload };
};

/**
 * Sets all filters at once (replaces existing filters).
 * Used for bulk updates like removing a filter value.
 * @param {Object} filters - The complete filters object
 * @param {string|number} offerId - The offer ID for localStorage persistence
 */
export const setOfferHistoryFilters = (filters, offerId) => {
  return {
    type: CASES.SET_OFFER_HISTORY_FILTERS,
    payload: { filters, offerId },
  };
};

/**
 * Loads saved filters from localStorage for a specific offer.
 * @param {string|number} offerId - The offer ID to load filters for
 */
export const loadOfferHistoryFilters = (offerId) => {
  return { type: CASES.LOAD_OFFER_HISTORY_FILTERS, payload: { offerId } };
};

/**
 * Clears all filter values and search text without resetting other state.
 * @param {string|number} offerId - The offer ID to clear filters for (removes from localStorage)
 */
export const clearOfferHistoryFilters = (offerId) => {
  return { type: CASES.CLEAR_OFFER_HISTORY_FILTERS, payload: { offerId } };
};
